import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ForgeRunnerModule = withAsync({
	loader: lazyForPaint(
		() =>
			import(/* webpackChunkName: "forge-runner" */ /* webpackPreload: true */ './forge-runner'),
	),
	LoadingSkeleton: () => null,
});
